import React from "react";
import { useCampaign } from "../../context/CampaignContext";
import plate from "../../assets/plate.png";
import megaphone from "../../assets/megaphone.svg";
import "./Schedule.css";

const CARD_COLORS = (index: number, total: number): string => {
  if (index === 0) return "#C8222A";
  if (index === total - 1) return "#2E8B3F";
  return "#FFC042";
};

export function Schedule() {
  const { campaign } = useCampaign();
  const total = campaign.schedule.length;

  return (
    <section className="schedule" id="cronograma">
      <div className="container schedule-container">
        <div className="schedule__header" data-reveal>
          <h2 className="schedule__title">
            Fique ligado nas datas{" "}
            <br className="responsive-break" />
            para não perder a carona!
          </h2>
          <img
            className="schedule__plate"
            src={plate}
            alt="Placa de carro escrito De Carona com Toro 16.07.26"
          />
        </div>

        <div className="schedule__cards">
          {campaign.schedule.map((item, index) => (
            <div
              className="schedule__card"
              key={item.title}
              data-reveal
              style={{ "--reveal-delay": `${index * 110}ms` } as React.CSSProperties}
            >
              <div
                className="schedule__card-color"
                style={{ backgroundColor: CARD_COLORS(index, total) }}
              >
                {item.date === "icon" ? (
                  <img src={megaphone} alt="Alerta de data megafone" />
                ) : (
                  item.date
                )}
              </div>

              <div className="schedule__card-content">
                <h3 className="schedule__card-title">{item.title}</h3>
                {item.extraTitle || item.extraDescription ? (
                  <>
                    {item.extraTitle && <h4 className="schedule__card-extra-title">{item.extraTitle}</h4>}
                    {item.extraDescription && <p className="schedule__card-date-extra">{item.extraDescription}</p>}
                  </>
                ) : null}
              </div>
              {/* <img
                className="schedule__card-flag"
                src={flagBackground}
                alt=""
                aria-hidden="true"
              /> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
